import { apiClient } from "@base/api/client";
import type { MemberSubscriptionsResponse } from "@features/admin/model/types";

export async function fetchMemberSubscriptions(companyId: number): Promise<MemberSubscriptionsResponse> {
  const { data } = await apiClient.get<MemberSubscriptionsResponse>(
    `/82office/membership/api/admin/members/${companyId}/subscriptions`,
  );
  return data;
}
